import React, { useState, useEffect, useRef } from "react";
// 1. Añadimos 'useNavigate' a las importaciones
import { Link, useNavigate } from "react-router-dom"; 
import { ToastContainer, toast } from "react-toastify";
import axios from "axios";
import { isAuth, getCokie, signout } from "../helpers/auth"; 
import Navigation from "../screens/Navigation.jsx";
import authSvgwww from "../assests/foto.png";

// 2. Removemos ({ history }) de los parámetros ya que no llegará por ahí
const Private = () => {
  const [formData, setFormData] = useState({
    name: "",
    photoSelected: "",
    namefile: "",
    files: [],
    email: "",
    password: "",
    textChange: "Actualizar perfil",
    rol: "",
    foto: ""
  });

  const fileInputRef = useRef(null);
  
  // 3. Inicializamos el hook de navegación
  const navigate = useNavigate();

  const fileSelectHandler = (file) => {
    if (file && file[0]) {
      const reader = new FileReader();
      
      reader.onload = (e) => {
        setFormData((prev) => ({
          ...prev,
          photoSelected: reader.result,
          files: file,
          namefile: file[0].name 
        }));
      };
      
      reader.readAsDataURL(file[0]);
    }
  };

  const loadProfile = () => {
    const token = getCokie("token");
    axios
      .get(`${process.env.REACT_APP_API_URL}/users/user/${isAuth()._id}`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      })
      .then((res) => {
        const { rol, name, email, foto, password } = res.data;
        setFormData((prev) => ({
          ...prev,
          rol,
          name,
          email,
          foto,
          password: password || "" 
        }));
      })
      .catch((err) => {
        console.error(err);
        toast.error(`Error al cargar la información: ${err.response?.statusText || err.message}`);
        if (err.response?.status === 401) {
          signout(() => {
            // 4. Cambiamos 'history.push("/login")' por 'navigate("/login")'
            navigate("/login");
          });
        }
      });
  };

  useEffect(() => {
    loadProfile();
  }, []);

  const { name, email, password, textChange, rol } = formData;

  const handleChange = (text) => (e) => {
    setFormData({ ...formData, [text]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setFormData((prev) => ({ ...prev, textChange: "Actualizando..." }));

    const data = new FormData();
    if (formData.files && formData.files[0]) {
      data.append("foto", formData.files[0]);
    }
    data.append("rol", rol);
    data.append("name", name);
    data.append("email", email);
    data.append("password", password);

    await axios
      .put(`${process.env.REACT_APP_API_URL}/users/user/${isAuth()._id}`, data)
      .then((res) => {
        setFormData((prev) => ({ ...prev, textChange: "Actualizar perfil" }));
        toast.info("Perfil actualizado satisfactoriamente");
        loadProfile();
      })
      .catch((err) => {
        setFormData((prev) => ({ ...prev, textChange: "Actualizar perfil" }));
        console.error(err);
        toast.error(`Error al actualizar: ${err.response?.statusText || err.message}`);
      });
  };

  const handleButtonClick = () => {
    if (fileInputRef.current) {
      fileInputRef.current.click();
    }
  };

  return (
    <>
      <Navigation />
      <div className="container mt-4">
        <ToastContainer />

        <Link
          to="/Login"
          onClick={(e) => {
            e.preventDefault();
            signout(() => {
              // 5. También puedes usar navigate aquí en vez de redirigir forzosamente la ventana si lo deseas
              window.location.href = "/login";
            });
          }}
          className="nav-link btn btn-info text-light w-100 mb-4"
        >
          Cerrar sesión
        </Link>

        <div className="row d-flex justify-content-center align-items-center">
          <div className="col-md-6 p-4 rounded-left">
            <form onSubmit={handleSubmit}>
              <div className="form-group mb-3">
                <label className="form-label text-info">Rol</label>
                <input
                  className="form-control my-1"
                  disabled={true}
                  type="text"
                  placeholder="Rol"
                  onChange={handleChange("rol")}
                  value={rol}
                />
              </div>
              <div className="form-group mb-3">
                <label className="form-label text-info">Correo</label>
                <input
                  className="form-control my-1"
                  disabled={true}
                  type="email"
                  placeholder="Email"
                  onChange={handleChange("email")}
                  value={email}
                />
              </div>
              <div className="form-group mb-3">
                <label className="form-label text-info">Nombre</label>
                <input
                  className="form-control my-1"
                  disabled={true}
                  type="text"
                  placeholder="Name"
                  onChange={handleChange("name")}
                  value={name}
                />
              </div>
              <div className="form-group mb-3">
                <label className="form-label text-info">Contraseña</label>
                <input
                  className="form-control my-1"
                  type="password"
                  placeholder="Nueva contraseña"
                  onChange={handleChange("password")}
                  value={password}
                />
              </div>

              <input
                type="file"
                className="form-control d-none"
                onChange={(e) => {
                  fileSelectHandler(e.target.files);
                }}
                ref={fileInputRef}
                accept="image/*"
              />
              
              <button type="submit" className="btn btn-warning w-100 mt-2">
                {textChange} {formData.namefile ? `(${formData.namefile})` : ""}
              </button>
            </form>
          </div>
          
          <div className="col-md-6 p-4 rounded-right text-center">
            <img
              className="img-fluid rounded shadow-sm"
              style={{ cursor: "pointer", maxHeight: "300px", objectFit: "cover" }}
              src={formData.photoSelected ? formData.photoSelected : `${process.env.REACT_APP_URL}/collections/${formData.foto}`}
              alt="Avatar Perfil"
              onClick={handleButtonClick}
              onError={(e) => {
                e.target.src = authSvgwww;
                e.target.style = "padding: 3px; margin: 1px; max-height: 350px;";
              }}
            />
            <p className="text-muted small mt-2">Haz clic en la imagen para cambiarla</p>
          </div>
        </div>
      </div>
    </>
  );
};

export default Private